module.exports = __webpack_public_path__ + "img/9788984291638.966b4c4e.jpg";